/**
* DevExpress Dashboard (_localization-ids.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizationId = void 0;
exports.localizationId = {
    FilterElementShowAllItem: 'DashboardStringId.FilterElementShowAllItem',
    DateTimeQuarterFormat: 'DashboardStringId.DateTimeQuarterFormat',
    buttonNames: {
        ClearMasterFilter: 'DashboardStringId.ActionClearMasterFilter',
        ClearSelection: 'DashboardStringId.ActionClearSelection',
        ElementSelection: 'DashboardStringId.ActionOtherValues',
        DrillUp: 'DashboardStringId.ActionDrillUp',
        ExportTo: 'DashboardStringId.ActionExportTo',
        ExportToPdf: 'DashboardStringId.ActionExportToPdf',
        ExportToImage: 'DashboardStringId.ActionExportToImage',
        ExportToExcel: 'DashboardStringId.ActionExportToExcel',
        ExportTemplate: 'DashboardStringId.ActionExportTemplate',
        AllowMultiselection: 'DashboardStringId.ActionAllowMultiselection',
        ButtonCancel: 'DashboardStringId.ButtonCancel',
        ButtonOK: 'DashboardStringId.ButtonOK',
        ButtonReset: 'DashboardStringId.ButtonReset',
        ButtonSubmit: 'DashboardStringId.ButtonSubmit',
        ButtonExport: 'DashboardStringId.ButtonExport',
        InitialExtent: 'DashboardStringId.InitialExtent',
        GridResetColumnWidths: 'DashboardStringId.GridResetColumnWidths',
        GridSortAscending: 'DashboardStringId.GridSortAscending',
        GridSortDescending: 'DashboardStringId.GridSortDescending',
        GridClearSorting: 'DashboardStringId.GridClearSorting',
        AddTimePeriod: 'DashboardStringId.ActionSelectDateTimePeriod',
        CustomPeriod: 'DashboardStringId.RangeFilterCustomDateTimePeriod',
        SelectDate: 'DashboardStringId.SelectDate'
    },
    labelName: {
        ParametersFormCaption: 'DashboardStringId.ParametersFormCaption',
        ParametersFormAllowNullColumnCaption: 'DashboardStringId.ParametersFormAllowNullColumnCaption',
        ParametersFormValueColumnCaption: 'DashboardStringId.ParametersFormValueColumnCaption',
        ParametersFormNameColumnCaption: 'DashboardStringId.ParametersFormNameColumnCaption',
        ParametersFormCalendarTodayButton: 'DashboardStringId.ParametersFormCalendarTodayButton',
        PageLayout: 'DashboardStringId.PageLayout',
        PageLayoutAuto: 'DashboardStringId.PageLayoutAuto',
        PageLayoutPortrait: 'DashboardStringId.PageLayoutPortrait',
        PageLayoutLandscape: 'DashboardStringId.PageLayoutLandscape',
        PaperKind: 'DashboardStringId.PaperKind',
        PaperKindLetter: 'DashboardStringId.PaperKindLetter',
        PaperKindLegal: 'DashboardStringId.PaperKindLegal',
        PaperKindExecutive: 'DashboardStringId.PaperKindExecutive',
        PaperKindA5: 'DashboardStringId.PaperKindA5',
        PaperKindA4: 'DashboardStringId.PaperKindA4',
        PaperKindA3: 'DashboardStringId.PaperKindA3',
        ScaleMode: 'DashboardStringId.ScaleMode',
        ScaleModeNone: 'DashboardStringId.ScaleModeNone',
        ScaleModeUseScaleFactor: 'DashboardStringId.ScaleModeUseScaleFactor',
        ScaleModeAutoFitToPagesWidth: 'DashboardStringId.ScaleModeAutoFitToPagesWidth',
        AutoFitPageCount: 'DashboardStringId.AutoFitPageCount',
        ScaleFactor: 'DashboardStringId.ScaleFactor',
        PrintHeadersOnEveryPage: 'DashboardStringId.PrintHeadersOnEveryPage',
        FitToPageWidth: 'DashboardStringId.FitToPageWidth',
        SizeMode: 'DashboardStringId.SizeMode',
        SizeModeNone: 'DashboardStringId.SizeModeNone',
        SizeModeStretch: 'DashboardStringId.SizeModeStretch',
        SizeModeZoom: 'DashboardStringId.SizeModeZoom',
        AutoArrangeContent: 'DashboardStringId.AutoArrangeContent',
        ImageFormat: 'DashboardStringId.ImageFormat',
        ExcelFormat: 'DashboardStringId.ExcelFormat',
        CsvValueSeparator: 'DashboardStringId.CsvValueSeparator',
        ExportFilters: 'DashboardStringId.ExportFilters',
        ExportParameters: 'DashboardStringId.ExportParameters',
        IncludeExportDashboardState: 'DashboardStringId.IncludeExportDashboardState',
        DashboardStatePosition: 'DashboardStringId.DashboardStatePosition',
        Resolution: 'DashboardStringId.Resolution',
        ShowTitle: 'DashboardStringId.ShowTitle',
        Title: 'DashboardStringId.Title',
        FileName: 'DashboardStringId.FileName',
        FilterStatePresentationAfter: 'DashboardStringId.FilterStatePresentationAfter',
        FilterStatePresentationAfterAndSplitPage: 'DashboardStringId.FilterStatePresentationAfterAndSplitPage',
        FilterStatePresentationSplitSheet: 'DashboardStringId.FilterStatePresentationSplitSheet',
        SelectRange: 'DashboardStringId.RangeFilterSelectRange',
        RangeFilterSelectRangeFromCaption: 'DashboardStringId.RangeFilterSelectRangeFromCaption',
        RangeFilterSelectRangeToCaption: 'DashboardStringId.RangeFilterSelectRangeToCaption'
    },
    sparkline: {
        TooltipStartValue: 'DashboardStringId.SparklineTooltipStartValue',
        TooltipEndValue: 'DashboardStringId.SparklineTooltipEndValue',
        TooltipMinValue: 'DashboardStringId.SparklineTooltipMinValue',
        TooltipMaxValue: 'DashboardStringId.SparklineTooltipMaxValue'
    },
    MessageCustomItemIsNotSupported: 'DashboardStringId.MessageCustomItemIsNotSupported',
    MessageGridHasNoData: 'DashboardStringId.MessageGridHasNoData',
    MessagePivotHasNoData: 'DashboardStringId.MessagePivotHasNoData',
    PivotGridGrandTotal: 'DashboardStringId.PivotGridGrandTotal',
    PivotGridTotal: 'DashboardStringId.PivotGridTotal',
    ChartTotalValue: 'DashboardStringId.ChartTotalValue',
    ParametersSelectorText: 'DashboardStringId.ParametersSelectorText',
    OpenCaption: 'DashboardStringId.OpenCaption',
    HighCaption: 'DashboardStringId.HighCaption',
    LowCaption: 'DashboardStringId.LowCaption',
    CloseCaption: 'DashboardStringId.CloseCaption',
    NumericFormatUnitSymbolThousands: 'DashboardStringId.NumericFormatUnitSymbolThousands',
    NumericFormatUnitSymbolMillions: 'DashboardStringId.NumericFormatUnitSymbolMillions',
    NumericFormatUnitSymbolBillions: 'DashboardStringId.NumericFormatUnitSymbolBillions',
    FilterElementCheckedComboBoxNoDataCaption: 'DashboardStringId.FilterElementCheckedComboBoxNoDataCaption',
    FilterElementRadioComboBoxNoDataCaption: 'DashboardStringId.FilterElementRadioComboBoxNoDataCaption',
    FilterElementNoDataToDisplay: 'DashboardStringId.FilterElementNoDataToDisplay',
    OlapRaggedHierarchyNoneItemCaption: 'DashboardStringId.OlapRaggedHierarchyNoneItemCaption',
    TreemapLabelArgumentTemplate: 'DashboardStringId.TreemapLabelArgumentTemplate',
    TreemapLabelValueTemplate: 'DashboardStringId.TreemapLabelValueTemplate',
    SearchNullValuePrompt: 'DashboardStringId.SearchNullValuePrompt',
    LegendItemFormatString: 'DashboardStringId.LegendItemFormatString'
};
